import { Button, Form, Input, Modal, Select } from "antd";
import Draggable from "react-draggable";

import { formItemLayout, inputLayout } from "../../../constants/ApplicationConstants/FormConstants";
import FormInputRules from "../../../util/FormInputRules";
import { General } from "../../../util/General";
import CircularProgressBar from "../../common/CircularProgressBar";
import useCreateParking from "./index.hook";
import { ParkingRequestTypeConstant, ParkingRequestTypeIdConstant } from "../../../constants/DatabaseConstants/ParkingConstants";
import { useReactDraggable } from "../../../hooks/useReactDraggable";

import type { keyFOBDetails } from "../../../shared/interface/parking.interface";

interface CreateParkingProps {
  isVisible: boolean;
  handleOnClose: () => void | undefined;
  handleRefreshList: () => void | undefined;
}

const CreateParking = (props: CreateParkingProps) => {
  const config = useCreateParking(props);

  /* HOOK */
  const { bounds, onStart } = useReactDraggable();

  return (
    <Modal
      title={<div className="modal-container">{"Add Request Parking"}</div>}
      maskClosable={false}
      afterClose={() => {
        config.form.resetFields();
        config.resetField();
      }}
      open={props.isVisible}
      onCancel={props.handleOnClose}
      centered
      width={"50%"}
      footer={null}
      modalRender={(modal) => (
        <Draggable bounds={bounds} handle=".ant-modal-header" onStart={(event, uiData) => onStart(event as any, uiData)}>
          {modal}
        </Draggable>
      )}
    >
      <Form className="modalForm" {...formItemLayout} form={config.form} onFinish={config.handleSubmit}>
        <Form.Item {...inputLayout} name="request_type_id" label="Request Type" rules={[FormInputRules.requiredFieldSelectRule("request type")]}>
          <Select className="width100" showSearch getPopupContainer={(trigger) => trigger.parentElement} filterOption={General.searchFilterOnSelect} placeholder="Select request type">
            <Select.Option key={ParkingRequestTypeIdConstant.RETRIEVAL} value={ParkingRequestTypeIdConstant.RETRIEVAL}>
              {ParkingRequestTypeConstant.RETRIEVAL}
            </Select.Option>
            <Select.Option key={ParkingRequestTypeIdConstant.BOOKING} value={ParkingRequestTypeIdConstant.BOOKING}>
              {ParkingRequestTypeConstant.BOOKING}
            </Select.Option>
          </Select>
        </Form.Item>

        <Form.Item {...inputLayout} name="keyFOB" label="Enter KeyFob" normalize={General.inputWhiteSpaceRemove} rules={[FormInputRules.NumberValidationRule()]}>
          <div className="display-flex">
            <Input name="keyFOB" onChange={config.handleChangeKeyFob} />
            <Button className="gx-mb-0 button-gradiant display-flex ml10" onClick={config.handleVerifyKeyFOB}>
              Verify KeyFob
            </Button>
          </div>
        </Form.Item>

        <Form.Item {...inputLayout} name="mobile_user_id" label="Username" rules={[FormInputRules.requiredFieldSelectRule("user name")]}>
          <Select className="width100" disabled={config.isSubmitDisabled} showSearch allowClear getPopupContainer={(trigger) => trigger.parentElement} filterOption={General.searchFilterOnSelect} placeholder="Select username" value={config.selectedUserName} onChange={config.handleUserNameChange}>
            {config.keyFOBDetails?.map((item: keyFOBDetails) => (
              <Select.Option key={item.id} value={item?.mobileUser?.id}>
                {item?.fullName}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item className="form-button form-button-pr ">
          <Button className="gx-mb-0 button-gradiant" htmlType="submit" disabled={config.isSubmitDisabled}>
            {config.loading ? <CircularProgressBar /> : "Submit"}
          </Button>
        </Form.Item>

        <Form.Item className="form-button form-button-pr ">
          <Button className="gx-mb-0 button-gradiant" onClick={props.handleOnClose}>
            Close
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};
export default CreateParking;
